import { TextField, MenuItem } from "@mui/material"
import { useState, useEffect } from "react"
import { API } from "../../services/API/API";

export default function OriginSelect({value, onChange, onSelect, required, disabled, sx}){

    const [origins, setOrigins] = useState([]);

    useEffect(() => {

        API.getOrigins()
            .then(r => setOrigins(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [])

    const handleChange = e => {

        if(onChange) return onChange(e);

        if(onSelect) return onSelect(
            {...origins.find(o => o.id.toString() === e.target.value)}
        )
    }


    return <TextField
        label='Provenance'
        select
        size='small'
        value={origins.length > 0 ? value : ''}
        onChange={handleChange}
        required={required ? true : false}
        disabled={disabled ? true : false}
        sx={sx || {}}
    >
        {origins
            .sort((a,b) => a.title > b.title ? 1 : -1)
            .map(o => 
                <MenuItem key={o.id} value={o.id}>
                    {o.title}
                </MenuItem>
            ) 
        }
    </TextField>
}